import { Component } from '@angular/core';

@Component({
    selector: 'app-cookies',
    standalone: true,
    templateUrl: './cookies.component.html',
    styleUrl: './cookies.component.css'
})
export class CookiesComponent { }
